var React = require('react');

function Checkmark (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5 11c-.3 0-.6-.1-.8-.4l-4-5c-.3-.4-.2-1 .2-1.4.4-.3 1.1-.3 1.4.2l3.1 3.9L10.1.4c.3-.5.9-.6 1.4-.3.5.3.6.9.3 1.4l-6 9c-.1.3-.4.5-.8.5z"}));
}

Checkmark.defaultProps = {"width":"12","height":"11","viewBox":"0 0 12 11"};

module.exports = Checkmark;

Checkmark.default = Checkmark;
